import { changeShouldUpdateSuggestions } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/utils/utils.js';
/** Preserves the input's blank-state, source-only, and ordinary-query request policy. */
export function resolveAutosuggestQuery({ inputQuery, queryWithoutSourceMentions, }) {
    if (queryWithoutSourceMentions.trim().length === 0) {
        return inputQuery.trim().length > 0
            ? { kind: 'source-only' }
            : { kind: 'blank', query: queryWithoutSourceMentions };
    }
    return changeShouldUpdateSuggestions(queryWithoutSourceMentions)
        ? { kind: 'query', query: queryWithoutSourceMentions }
        : { kind: 'ignored' };
}
//# sourceMappingURL=resolveAutosuggestQuery.js.map